import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Chip, Link, Alert,
} from '@mui/material';
import { Warning as SOSIcon } from '@mui/icons-material';
import { useSOS } from '../contexts/SOSContext';

export default function SOSAlerts() {
  const { alerts, clearUnread } = useSOS();

  // Mark as read when page is opened
  clearUnread();

  const getLocationUrl = (a: ReturnType<typeof useSOS>['alerts'][0]) =>
    a.locationUrl || (a.latitude && a.longitude
      ? `https://maps.google.com/?q=${a.latitude},${a.longitude}`
      : null);

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <SOSIcon color="error" fontSize="large" />
        <Typography variant="h4" fontWeight={700}>SOS Alerts</Typography>
      </Box>

      <Alert severity="info" sx={{ mb: 3 }}>
        Shows real-time SOS alerts for this session. Historical alerts are recorded on each trip record — view them via the Trips page.
      </Alert>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Time</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Trip ID</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Message</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {alerts.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ color: 'text.secondary', py: 4 }}>
                  No SOS alerts this session
                </TableCell>
              </TableRow>
            )}
            {alerts.map((a, i) => (
              <TableRow key={a.alertId || i} sx={{ bgcolor: i === 0 ? 'error.50' : undefined }}>
                <TableCell>{new Date(a.timestamp).toLocaleString()}</TableCell>
                <TableCell>{a.userName || a.triggeredBy || '—'}</TableCell>
                <TableCell>
                  <Chip
                    label={a.userType || '—'}
                    color={a.userType === 'driver' ? 'primary' : 'secondary'}
                    size="small"
                  />
                </TableCell>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: 12 }}>{a.tripId || '—'}</TableCell>
                <TableCell>
                  {getLocationUrl(a) ? (
                    <Link href={getLocationUrl(a)!} target="_blank" rel="noopener">
                      {a.latitude?.toFixed(4)}, {a.longitude?.toFixed(4)}
                    </Link>
                  ) : '—'}
                </TableCell>
                <TableCell>{a.message || '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
